import React, { useState, useEffect } from 'react';
import { loadPassportData, savePassportData } from './translatedata'; 

import './cabinet-zdo-passport.css';

const ZDOPassport = ({kg_id}) => {
  const [passportData, setPassportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Загрузка данных при монтировании
  useEffect(() => {

    async function api() {
      setLoading(true);
      const data = await loadPassportData(kg_id);
      setPassportData(data);
      setLoading(false);
    }

    if(kg_id) api();

  }, [kg_id]);

  

  const handleSave = async () => {

    try {
      setSaving(true);
      await savePassportData({kg_id, data:passportData});
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      alert('Помилка збереження даних');
    } finally {
      setSaving(false);
    }
  };

  const handleInputChange = (field, value) => {
    setPassportData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleWorkModeChange = (index, field, value) => {
    setPassportData(prev => ({
      ...prev,
      workModes: prev.workModes.map((mode, i) => 
        i === index ? { ...mode, [field]: value } : mode
      )
    }));
  };

  const handleWorkDayChange = (day, checked) => {
    setPassportData(prev => ({
      ...prev,
      workDays: {
        ...prev.workDays,
        [day]: checked
      }
    }));
  };


  if (loading) {
    return <div className="text-center p-4">Завантаження...</div>;
  }

  if (!passportData) {
    return <div className="text-center p-4">Помилка завантаження даних</div>;
  }


  return (
    <main className="passport-main-content passport-page">
      <div className="container-fluid">
        <div className="row">
          <div className="content-wrapper passport-content-wrapper">
            <div className="card card-body p-4">
              <div className="row g-3 align-items-center">
                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="type">Тип</label>
                </div>
                <div className="passport-value-col">
                  <select 
                    id="type" 
                    className="form-select passport-form-select"
                    value={passportData.type}
                    onChange={(e) => handleInputChange('type', e.target.value)}
                  >
                    <option>Дошкільний підрозділ</option>
                    <option>ДНЗ</option>
                    <option>Приватний ЗДО</option>
                  </select>
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="ownership">Власність</label>
                </div>
                <div className="passport-value-col">
                  <select 
                    id="ownership" 
                    className="form-select passport-form-select"
                    value={passportData.ownership}
                    onChange={(e) => handleInputChange('ownership', e.target.value)}
                  >
                    <option>Комунальний</option>
                    <option>Державний</option>
                    <option>Приватний</option>
                  </select>
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="specialization">Спеціалізація</label>
                </div>
                <div className="passport-value-col">
                  <select 
                    id="specialization" 
                    className="form-select passport-form-select"
                    value={passportData.specialization}
                    onChange={(e) => handleInputChange('specialization', e.target.value)}
                  >
                    <option>Без спеціалізації</option>
                    <option>Мовна</option>
                    <option>Інклюзивна</option>
                  </select>
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="extra">Додатково має</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="extra"
                    type="text"
                    className="form-control passport-form-control"
                    value={passportData.extra}
                    onChange={(e) => handleInputChange('extra', e.target.value)}
                  />
                </div>
              </div>

              <hr className="passport-my-4" />

              <h6 className="passport-section-title mb-3">Контакти</h6>
              <div className="row g-3 align-items-center">
                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="address">Адреса</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="address"
                    type="text"
                    className="form-control passport-form-control"
                    value={passportData.address}
                    onChange={(e) => handleInputChange('address', e.target.value)}
                  />
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="district">Район</label>
                </div>
                <div className="passport-value-col">
                  <select 
                    id="district" 
                    className="form-select passport-form-select"
                    value={passportData.district}
                    onChange={(e) => handleInputChange('district', e.target.value)}
                  >
                    <option>Голосіївський</option>
                    <option>Дарницький</option>
                    <option>Дніпровський</option>
                    <option>Деснянський</option>
                    <option>Святошинський</option>
                    <option>Солом'янський</option>
                    <option>Оболонський</option>
                    <option>Печерський</option>
                    <option>Подільський</option>
                    <option>Шевченківський</option>
                  </select>
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="phone">Телефон</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="phone"
                    type="tel"
                    className="form-control passport-form-control"
                    value={passportData.phone}
                    onChange={(e) => handleInputChange('phone', e.target.value)}
                  />
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="email">Email</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="email"
                    type="email"
                    className="form-control passport-form-control"
                    value={passportData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                  />
                </div>

                <div className="passport-label-col">
                  <label className="passport-field-label" htmlFor="site">Сайт</label>
                </div>
                <div className="passport-value-col">
                  <input
                    id="site"
                    type="url"
                    className="form-control passport-form-control"
                    value={passportData.site}
                    onChange={(e) => handleInputChange('site', e.target.value)}
                  />
                </div>
              </div>

              <hr className="passport-my-4" />

              <h6 className="passport-section-title mb-3">Режим роботи</h6>
              <div className="row g-3 passport-work-schedule">
                <div className="col-md-4">
                  <label className="form-label passport-form-label" htmlFor="mode1">Режим роботи</label>
                  <div className="passport-stack-2">
                    {passportData.workModes.map((mode, index) => (
                      <select
                        key={index}
                        className="form-select passport-form-select"
                        value={mode.mode}
                        onChange={(e) => handleWorkModeChange(index, 'mode', e.target.value)}
                      >
                        <option>Повний 12-годинний день</option>
                        <option>Скорочений 10,5-годинний день</option>
                        <option>Короткотривалий</option>
                      </select>
                    ))}
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label passport-form-label" htmlFor="start1">Початок роботи</label>
                  <div className="passport-stack-2">
                    {passportData.workModes.map((mode, index) => (
                      <input
                        key={index}
                        type="text"
                        className="form-control passport-form-control"
                        value={mode.start}
                        onChange={(e) => handleWorkModeChange(index, 'start', e.target.value)}
                      />
                    ))}
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label passport-form-label" htmlFor="end1">Завершення роботи</label>
                  <div className="passport-stack-2">
                    {passportData.workModes.map((mode, index) => (
                      <input
                        key={index}
                        type="text"
                        className="form-control passport-form-control"
                        value={mode.end}
                        onChange={(e) => handleWorkModeChange(index, 'end', e.target.value)}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <div className="row g-3 mt-2 align-items-center">
                <div className="passport-label-col">
                  <label className="form-label passport-form-label m-0">Робочі дні</label>
                </div>
                <div className="passport-value-col">
                  <div className="passport-weekdays align-items-center">
                    {[
                      { id: 'wd1', day: 'monday', label: 'Пн' },
                      { id: 'wd2', day: 'tuesday', label: 'Вт' },
                      { id: 'wd3', day: 'wednesday', label: 'Ср' },
                      { id: 'wd4', day: 'thursday', label: 'Чт' },
                      { id: 'wd5', day: 'friday', label: 'Пт' },
                      { id: 'wd6', day: 'saturday', label: 'Сб' },
                      { id: 'wd7', day: 'sunday', label: 'Нд' }
                    ].map(({ id, day, label }) => (
                      <div key={id} className="form-check passport-form-check passport-form-check-inline">
                        <input
                          className="form-check-input passport-form-check-input"
                          type="checkbox"
                          id={id}
                          checked={passportData.workDays[day]}
                          onChange={(e) => handleWorkDayChange(day, e.target.checked)}
                        />
                        <label className="form-check-label passport-form-check-label" htmlFor={id}>
                          {label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="row g-3 mt-1 align-items-center">
                <div className="passport-label-col">
                  <label className="form-label passport-form-label m-0" htmlFor="holidays">Працює в свята</label>
                </div>
                <div className="passport-value-col">
                  <div className="passport-form-check">
                    <input
                      className="form-check-input passport-form-check-input"
                      type="checkbox"
                      id="holidays"
                      checked={passportData.worksOnHolidays}
                      onChange={(e) => handleInputChange('worksOnHolidays', e.target.checked)}
                    />
                    <label className="form-check-label passport-form-check-label" htmlFor="holidays">Так</label>
                  </div>
                </div>
              </div>

              <hr className="passport-my-4" />

              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label passport-form-label" htmlFor="manager">Керівник</label>
                  <input
                    id="manager"
                    type="text"
                    className="form-control passport-form-control"
                    value={passportData.manager}
                    onChange={(e) => handleInputChange('manager', e.target.value)}
                  />
                </div>
              </div>

              <div className="passport-mt-4">
                <button className="btn btn-primary passport-btn passport-btn-primary" onClick={handleSave}>
                  Зберегти зміни
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ZDOPassport;